import {
	Component,
	OnInit,
	HostBinding,
	Input,
	AfterViewInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef
} from '@angular/core';
import { LayoutConfigService } from '../../../../core/services/layout-config.service';
import * as objectPath from 'object-path';
import { Router, ActivatedRoute } from '@angular/router';
import { TokenService } from '../../../../services/token.service';
import { AuthService } from './../../../../services/auth.service';
import { HttpClient } from '@angular/common/http';
import { apiUrl } from './../../../../config/api-url';
import { PrivateLabelService } from '../../../pages/showroom/private-label.service';
import { Observable } from 'rxjs';
import { UserDataService } from '../../../../services/shared/user-data.service';
import { map } from 'rxjs/operators';
import moment from 'moment';

@Component({
	selector: 'm-topbar',
	templateUrl: './topbar.component.html',
	styleUrls: ['./topbar.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class TopbarComponent implements OnInit, AfterViewInit {
	@HostBinding('id') id = 'm_header_nav';
	@HostBinding('class')
	classes = 'm-stack__item m-stack__item--fluid m-header-head';

	public daysLeft = 30;

	@Input() searchType: any;

	constructor(
		private layoutConfigService: LayoutConfigService,
		public tokenService: TokenService,
		public authService: AuthService,
		private http: HttpClient,
		private privateLabelService: PrivateLabelService,
		private changeDetection: ChangeDetectorRef,
		private userDataService: UserDataService,
		private router: Router
	) {
		this.layoutConfigService.onLayoutConfigUpdated$.subscribe(model => {
			const config = model.config;
			this.searchType = objectPath.get(config, 'header.search.type');
		});
	}

	public get trial$(): Observable<boolean> {
		return this.tokenService.trial$;
	}

	public get daysLeft$(): Observable<number> {
		return this.userDataService.userData$.pipe(
			map(data => {
				if (!data || !data.company || !data.company.expires_in) {
					return -1;
				}
				const a = moment().startOf('day');
				const b = moment(data.company.expires_in);
				const diffDays = b.diff(a, 'days');
				return diffDays;
			})
		);
	}

	ngOnInit(): void {
		this.daysLeft$.subscribe();
		// if (!this.isShowroomUser()) {
		// 	return;
		// }
		// this.http.get(apiUrl + '/showroom/trial').subscribe((response: any) => {
		// 	this.daysLeft = response.days_left;
		// 	try {
		// 		this.changeDetection.detectChanges();
		// 	} catch (e) {
		// 		//
		// 	}
		// })
	}

	public isPrivateLabel(): Observable<boolean> {
		return this.privateLabelService.isPrivateLabel$;
	}

	public isShowroomUser(): boolean {
		const roles = this.tokenService.getRoles();
		return roles.includes('showroom_admin') || roles.includes('sales');
	}

	public isVendorUser(): boolean {
		const roles = this.tokenService.getRoles();
		return roles.includes('vendor_user') || roles.includes('vendor_admin');
	}

	public getModulePrefix(): string {
		return this.isShowroomUser() ? 'showroom' : 'vendor';
	}

	ngAfterViewInit(): void { }
}
